import React from "react";
import "./App.css";
import "../src/assets/css/md-font.min.css";
import "react-toastify/dist/ReactToastify.css";
import { Route, Switch, Redirect } from "react-router-dom";
import SignIn from "./components/register/sign in/index";
import Login from "./components/register/login";
import ForgetPass from "./components/register/forgetPassword";
import { PrivetRoute } from "./utils/privetComponents";
import { ToastContainer } from "react-toastify";
import Main from "./components/Main/index";
import Dial from "./components/Main/dial";
import Dashboard from "./components/general/index";
import ModalProvider from "./components/general/ModalContext";
import CustomerInfoForm from "./components/Main/form";

function App() {
  return (
    <>
      <ModalProvider>
        <ToastContainer
          position="top-center"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={true}
          position="bottom-center"
          draggable
        ></ToastContainer>
        <Switch>
          <Route component={Login} path="/login"></Route>
          <Route component={SignIn} path="/register"></Route>
          <Route component={ForgetPass} path="/forgetPassword"></Route>
          <PrivetRoute component={Dashboard} path="/main"></PrivetRoute>
          <PrivetRoute
            path="/form"
            component={CustomerInfoForm}
            exact
          ></PrivetRoute>
          <PrivetRoute
            path="/"
            component={() => <Redirect to="/main"></Redirect>}
            exact
          ></PrivetRoute>
        </Switch>
      </ModalProvider>
    </>
  );
}

export default App;
